import { render } from "./HeaderGimli.vue?vue&type=template&id=9a834376&scoped=true"
import script from "./HeaderGimli.vue?vue&type=script&lang=js"
export * from "./HeaderGimli.vue?vue&type=script&lang=js"

import "./HeaderGimli.vue?vue&type=style&index=0&id=9a834376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a834376"]])

export default __exports__